(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-rows-collapsible/assets/javascripts/ball-rows-collapsible-collection.js') >= 0) return;  svs.modules.push('/components/tur/ball-rows-collapsible/assets/javascripts/ball-rows-collapsible-collection.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.rows = svs.tur.ball.rows || {};
svs.tur.ball.rows.collapsible = svs.tur.ball.rows.collapsible || {};


class CollapsibleCollection extends svs.tur.Base {
  constructor(_ref) {
    let {
      collection = [],
      className = 'ball-rows-collapsible-collection'
    } = _ref;
    super({
      collection,
      className
    });
    this.collection = collection;
    this._collapsed = true;
  }
  classNames() {
    return ['ball-rows-collapsible-collection-default'];
  }
  render() {
    let visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (!visible) {
      this.$el.style.opacity = 0;
    }
    this.collection.forEach(collapsible => {
      $(this.$el).append(collapsible.render(visible));
    });
    return this.$el;
  }
  collapse() {
    const tl = gsap.timeline();
    if (!this._collapsed) {
      this._collapsed = true;
      this.collection.reverse().forEach(collapsible => {
        tl.add(collapsible.collapse(), '<.2');
      });
    }
    return tl;
  }
  expand() {
    const tl = gsap.timeline();
    if (this._collapsed) {
      this._collapsed = false;
      this.collection.forEach(collapsible => {
        tl.add(collapsible.expand(), '<.2');
      });
    }
    return tl;
  }
}
svs.tur.ball.rows.collapsible.Collection = CollapsibleCollection;

 })(window);